import { render, staticRenderFns } from "./ReportDescriptionCard.vue?vue&type=template&id=94727b30&scoped=true"
import script from "./ReportDescriptionCard.vue?vue&type=script&lang=ts"
export * from "./ReportDescriptionCard.vue?vue&type=script&lang=ts"
import style0 from "./ReportDescriptionCard.vue?vue&type=style&index=0&id=94727b30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94727b30",
  null
  
)

export default component.exports